import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkArchiveActTeam, IActTeamStore, IActTeamActions } from '../types';

const onArchiveActTeam: IThunkArchiveActTeam = thunk(
  async ({ setActTeams }: Actions<IActTeamActions>, payload, { getState }) => {
    const localState = getState() as IActTeamStore;
    const { clinicId, actTeamId } = payload;

    await api.actTeam.archiveActTeam(clinicId, actTeamId);

    const updatedList = localState.list.map(item =>
      item.id !== Number(actTeamId) ? item : { ...item, isArchived: true },
    );

    setActTeams({ items: updatedList });
  },
);

export default onArchiveActTeam;
